// Tiny WebAudio sound kit — warm, gentle tones synthesised on the fly (no audio files).
let ctx = null;
let muted = false;

function getCtx() {
  if (typeof window === "undefined") return null;
  if (!ctx) {
    try {
      const AC = window.AudioContext || window.webkitAudioContext;
      ctx = AC ? new AC() : null;
    } catch (e) {
      ctx = null;
    }
  }
  return ctx;
}

export function unlockAudio() {
  const c = getCtx();
  if (c && c.state === "suspended") {
    c.resume().catch(() => {});
  }
}

export function setSoundMuted(m) {
  muted = m;
}

function note(freq, t0, dur, { type = "sine", gain = 0.14 } = {}) {
  if (muted) return;
  const c = getCtx();
  if (!c) return;
  try {
    const o = c.createOscillator();
    const g = c.createGain();
    o.type = type;
    o.frequency.value = freq;
    o.connect(g);
    g.connect(c.destination);
    const now = c.currentTime + t0;
    g.gain.setValueAtTime(0.0001, now);
    g.gain.linearRampToValueAtTime(gain, now + 0.02);
    g.gain.exponentialRampToValueAtTime(0.0001, now + dur);
    o.start(now);
    o.stop(now + dur + 0.03);
  } catch (e) {
    /* no-op */
  }
}

export const sfx = {
  pop() {
    note(523, 0, 0.16, { type: "triangle", gain: 0.12 });
  },
  tap() {
    note(440, 0, 0.1, { type: "sine", gain: 0.1 });
  },
  count() {
    note(620, 0, 0.16, { type: "triangle", gain: 0.12 });
  },
  success() {
    [523.25, 659.25, 783.99].forEach((f, i) => note(f, i * 0.12, 0.5, { gain: 0.15 }));
    note(1046.5, 0.34, 0.6, { gain: 0.1 });
  },
  complete() {
    [523.25, 659.25, 783.99, 1046.5].forEach((f, i) => note(f, i * 0.13, 0.6, { gain: 0.14 }));
  },
  tryAgain() {
    // soft, warm, descending — encouraging, never harsh
    note(440, 0, 0.22, { type: "sine", gain: 0.1 });
    note(370, 0.16, 0.3, { type: "sine", gain: 0.1 });
  },
};
